const About = () => {
    return (
        <div className="page">
            <div className="page-header">
                <h1>About Me</h1>
            </div>
            <div className="page-content">
                <p className='text-align-center'>As a Developer, my goal is to serve you. This app is meant to help you pursue the best verison of yourself by providing a fun and challenging way to implement positive habits and removing unwanted ones.</p>
                <p className='text-align-center'>You can reach me at athletecoder@gmail.com</p>
            </div>
        </div>
    )
}

export default About;